import "./privacyPolicy.css";

function PrivacyPolicy(){
    return (
    <div className="privacy-policy">
	<h1>Privacy Policy</h1>
	<p>
		<strong>
			Sentry Technologies appreciates your trust and is committed to protecting the privacy of information you make available to us.
		</strong>
	</p>
	<p>
		<strong>
            If you have a question about the information we collect, how we use it, or if you wish to delete, opt-out, correct, 
            or limit the use of your personal information, please submit a detailed, written request 
            to <a className="a-privacy-policy" href="mailto:software@sentryti.com">software@sentryti.com</a> or 
            to Sentry Technologies, 1414 W Sam Houston Pkwy N, Suite 140, Houston, TX 77043 and let us know how you prefer to be 
            contacted so we can verify your identity as needed to fulfill your request.
		</strong>
	</p>
	<hr />
	<div className="color-privacy-policy">
		<h4 className="h4-privacy-policy">What information do we collect?</h4>
		<p>
			Sentry Technologies collects information about you including (name, phone number, email address) when you…
		</p>
		<ul>
			<li>Use key services on our website at <a className="a-privacy-policy" href="/">dashboard.sentryti.com</a></li>
			<li className="li-privacy-policy">
				<ul>
					<li>Create an account</li>
					<li>Place an order</li>
					<li>Enroll in email and SMS notifications</li>
				</ul>
			</li>
			<li>Submit a product for service or repair</li>
			<li>Inquire about our services</li>
		</ul>
		<p>We maintain the data you share with us in a secure.</p>
		<p>
			We also gather information about how visitors to <a className="a-privacy-policy" href="/">dashboard.sentryti.com</a> navigate 
            their way through our website (including IP addresses and the broad demographic data associated with them).
		</p>
		<hr />
		<h4 className="h4-privacy-policy">How do we use the information we collect?</h4>
		<p>
			We only use information we collect from you for as long as it is reasonably required for a legitimate business purpose. 
            We are legally required to hold some types of information to fulfill our statutory obligations, such as for tax records, 
            or to confirm your warranty. We will hold your personal information on our systems for as long as necessary for the relevant activity.
		</p>
        <hr />
		<h4 className="h4-privacy-policy">Does our website use cookies?</h4>
		<p>
			Cookies are small data files that are stored on your computer by a website. Our website 
            at <a className="a-privacy-policy" href="/">dashboard.sentryti.com</a> will use cookies to...
		</p>
        <ul>
			<li>Recognize you when you return to our website</li>
			<li>Remember information you enter into forms on the website</li>
		</ul>
        <hr />
		<h4 className="h4-privacy-policy">
            Does Sentry Technologies sell email addresses or other information with any third parties?
        </h4>
		<p>
			Sentry Technologies does not rent, sell, or loan our email list or any other information that we gather to any third party.
		</p>
        <hr />
		<h4 className="h4-privacy-policy">
            Does Sentry Technologies offer SMS Text notification and phone calls?
        </h4>
		<p>
			By subscribing to Sentry Technologies mobile messages or phone calls, you agree to receive 
            recurring autodialed alert messages or phone calls to the telephone number used at the time of opt-in. 
            Message frequency may vary as a phone call's frequency. Message and data rates may apply. Consent is not 
            required as a condition of purchasing any goods or services. Terms & Conditions are subject to change. 
            The mobile carriers are not liable for delayed or undelivered messages.
		</p>
        <hr />
		<h4 className="h4-privacy-policy">
            How can I opt-out of Phone calls or SMS Text notifications?
        </h4>
		<p>
			To opt-out of phone call or Text message notifications, you can typically reply to the message with a keyword 
            that will automatically stop notifications by texting STOP, STOPALL, UNSUBSCRIBE, END, QUIT or CANCEL.
		</p>
        <hr />
		<h4 className="h4-privacy-policy">
            How does Sentry Technologies protect your information?
        </h4>
		<p>
			Sentry Technologies maintains its data in a secure, password-protected database and employs encryption 
            and other security technologies to protect the personal information. 
            Feel free to contact us for more information about security technologies employed by Sentry Technologies.
		</p>
        <p>
            We maintain physical, electronic, and procedural safeguards to protect the confidentiality and security of information transmitted to us. 
            To guard your information delivered to us electronically, our web sites use Secure Sockets Layer (SSL). 
            SSL encrypts your personal information and data stored by your devices, so only we can decode your information.
        </p>
        <p>
            Unfortunately, however, no data transmission over the Internet can be guaranteed to be 100% secure. 
            As a result, while we strive to protect your contact information, to the extent permitted by law, 
            we do not guarantee or warranty the security of any information you transmit to or from our web sites, and you do so at your own risk.
        </p>
        <p>
            We urge you to keep any password that you establish with us in a safe place and not to divulge it to anyone. 
            Also remember to log off your account and close your browser window when you have finished your visit. 
            This is to ensure that others cannot access your account, especially if you are sharing a computer with someone else or are using a computer in a public place.
        </p>
        <hr />
		<h4 className="h4-privacy-policy">
            What about user comments, reviews, feedback, and other submissions?
        </h4>
		<p>
			If, either unsolicited or at our request, you send comments or other feedback, including product or service reviews, 
            creative ideas, suggestions, proposals, photos, or other materials, whether online, by email, by postal mail, 
            or otherwise (collectively, 'comments'), you agree that we may, at any time, without restriction, edit for clarity, copy, 
            publish, distribute, translate and otherwise use in any medium any comments that you forward to us. 
            We are and shall be under no obligation (1) to maintain any comments in confidence; (2) to pay compensation for any comments; or (3) to respond to any comments.
		</p>
        <p>
            We may, but have no obligation to, monitor, edit or remove content that we determine in our sole discretion are unlawful, offensive, threatening, libelous, defamatory, 
            pornographic, obscene, or otherwise objectionable or violates any party’s intellectual property. You are solely responsible for any comments you make and their accuracy. 
            We take no responsibility and assume no liability for any comments posted by you or any third-party. 
            You agree that your comments do not violate any right of any third-party, including copyright, trademark, privacy, personality or other personal or proprietary right. 
            You further agree that your comments do not contain libelous or otherwise unlawful, abusive, or obscene material
        </p>
        <hr />
        <h4 className="h4-privacy-policy">
            Are these policies subject to change?
        </h4>
        <p>
            Yes, Sentry Technologies reserves the right to change these policies from time to time in order to better serve you, but any such changes will always be reflected here.
        </p>
        <hr />
        <h4 className="h4-privacy-policy">
            Children under the age of 16
        </h4>
        <p>
            <a className="a-privacy-policy" href="/">dashboard.sentryti.com</a> is not intended for children under 16 years of age. 
            We do not knowingly collect personal information from children under 16 or knowingly allow such persons to create 
            a <a className="a-privacy-policy" href="/">dashboard.sentryti.com</a> account. 
            If you are under 16, please do not use or provide any information on <a className="a-privacy-policy" href="/">dashboard.sentryti.com</a>.
        </p>
        <p>
            If you believe we might have any information from or about a child under 16, 
            please contact us using phone numbers or email address specified in the header paragraph of this document and we will delete the information.
        </p>
	</div>
</div>
  )
}

export default PrivacyPolicy;